// @flow
import { useEffect, useState } from 'preact/hooks';
import { useErrorModalContextDispatch } from '../../../storeProviders/errorModalStore';
import type { ErrorResponseType } from '../../../api/controllers/salesController';
import type { ErrorModalType } from '../../../storeProviders/errorModalStore';
import { useSalesDispatchContext } from '../../../storeProviders/salesAppStore';
import { route } from 'preact-router';
import {
  salesSessionExpiredRoute,
  salesAgentBlockedRoute,
} from '../../../alias/salesAppRoutes';
import { SalesApiErrorCodes } from '../../../api/controllers/salesController';

type SalesAppErrorModalType = {
  ...ErrorResponseType,
  errorModal?: ErrorModalType,
  customMsg?: boolean,
};

export default function useSalesAppError() {
  const [_error, setSalesAppErrorModal]: [
    SalesAppErrorModalType,
    (SalesAppErrorModalType) => SalesAppErrorModalType,
  ] = useState();

  const [salesAppError, setSalesAppError] = useState();

  const errorModalDispatch = useErrorModalContextDispatch();
  const salesDispatch = useSalesDispatchContext();

  const handleError = (error) => {
    switch (error.errorCode) {
      case SalesApiErrorCodes.SESSION_EXPIRED:
        handleRouting(salesSessionExpiredRoute.path);
        break;

      case SalesApiErrorCodes.AGENT_BLOCKED:
        salesDispatch({
          type: 'STORE_STATE',
          payload: {
            prevSalesAppError: error,
          },
        });
        handleRouting(salesAgentBlockedRoute.path);
        break;

      default:
        handleOtherErrorCodes();
        break;
    }

    function handleRouting(path) {
      salesDispatch({
        type: 'STORE_STATE',
        payload: {
          bottomSheetConfig: {
            showOverlay: false,
            moduleName: null,
          },
        },
      });
      route(path);
    }

    function handleOtherErrorCodes() {
      if (error.customMsg && error.errorCode) {
        setSalesAppError(error);
        errorModalDispatch({
          type: 'MODAL/CLOSE',
        });
      } else {
        setSalesAppError(null);
        errorModalDispatch({
          type: 'MODAL/OPEN',
          payload: {
            title: error.title || 'Error',
            errorCode: error.errorCode,
            message:
              error.message ||
              'Sorry, we are experiencing technical difficulties & are working to fix them. Please try again later.',
            onRetryClick: () => {},
            handleClose: () => {
              salesDispatch({
                type: 'SEND_MESSAGE',
                payload: {
                  actionName: 'closeSAApp',
                },
              });
            },
            isRetryAllowed: !!error && !!error.isRetryAllowed,
            hideCloseButton:
              !!error.errorModal && !!error.errorModal.hideCloseButton,
          },
        });
      }
    }
  };

  const handleSalesAppError = (error: SalesAppErrorModalType) => {
    if (error) {
      setSalesAppError(error);
      handleError(error);
    }
  };

  useEffect(() => {
    if (_error) handleSalesAppError(_error);
  }, [_error]);

  return { setSalesAppErrorModal, salesAppError };
}



// WEBPACK FOOTER //
// ./components/salesApp/hooks/useSalesAppError.js